import { ReactNode } from 'react';
import { titleize } from 'inflected';
import { Badge } from '@Components/Badge';
import { ClientLogo } from '@Components/NavBar/ClientSelector/ClientLogo';
import { AppearanceType, Background, Design, SizeType } from '@Components/designConstants';
import { useCompanyInfo } from '@src/utils/hooks/useCompanyInfo';

interface ActivityFeedClientBadgeProps {
  cid: string;
  size?: SizeType;
  appearance?: AppearanceType;
  className?: string;
}

// Renders nothing on the client-scoped route, where the page already names the client.
export const ActivityFeedClientBadge = ({
  cid,
  size,
  appearance,
  className
}: ActivityFeedClientBadgeProps): ReactNode => {
  const { cid: routeCid } = useCompanyInfo();
  if (routeCid) return null;

  return (
    <Badge
      size={size}
      design={Design.NEUTRAL}
      appearance={appearance}
      className={className}
      leadingElement={<ClientLogo cid={cid} unloader={null} background={Background.LIGHT} />}
    >
      {titleize(cid)}
    </Badge>
  );
};
